// SQA / self-host environment overlay
// Copied onto src/environments/environment.ts before ng build
export const environment = {
  production: false,
  // Point to YOUR Gateway APIs
  API: 'https://ifarm-gateway-apis.wadteam.dev/',
  URL_UPLOAD: 'https://ifarm-gateway-apis.wadteam.dev',
  GOOGLE_KEY: 'AIzaSyCdFDePFqp1JSeUyasD-LP2bUZreCeD9e4',

  URL_VERIFY_TOKEN: 'verify',
  URL_ADMD_LOGIN: 'admd/admdLogin',
  URL_ADMD_DEV_LOGIN: 'admd/devLogin',
  URL_ADMD_LOGOUT: 'admd/logout',
  URL_GATEWAY_CALLBACK: 'admd/gwCallback',
  URL_REFRESH_TOKEN: 'auth/refreshToken',
  URL_QUERY_ORG: 'org/queryORG',
  URL_UPDATE_SELECTED_ORG: 'org/updateSelectedOrg',
  URL_CLEAR_PLATFORM_TOKEN: 'org/clearPlatformToken',

  URL_GET_PROVINCE: 'util/provinces',
  URL_GET_DISTRICT: 'util/district',
  URL_GET_SUB_DISTRICT: 'util/subDistricts',
  URL_UPLOAD_IMAGE: 'util/uploadImage',
  URL_GET_CHILD_ORG_BY_NAME: 'childorg/findChildorgByname',
  URL_CREATE_CHILD_ORG: 'childorg/createChildOrg',
  URL_UPDATE_CHILD_ORG: 'childorg/updateChildOrg',
  URL_DELETE_CHILD_ORG: 'childorg/deleteChildOrg',
};
